import { render, staticRenderFns } from "./InstallButton.vue?vue&type=template&id=64b8c220&"
import script from "./InstallButton.vue?vue&type=script&lang=ts&"
export * from "./InstallButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports